import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "../../url"

export const financeApi = createApi({
  reducerPath: "financeApi",
  tagTypes: "Finance",
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: currentUrl,
    prepareHeaders: (headers) => {
      // Читаем токен при каждом запросе, чтобы использовать актуальное значение
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
        const token = accessToken.startsWith("Bearer ") 
          ? accessToken 
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
      }
      return headers
    },
  }),
  endpoints: (build) => ({
    getFinances: build.query({
   query: (params) => {
  const { start_date, end_date, page = 1, per_page = 10, salon_id } = params
  const queryParams = new URLSearchParams()
  if (start_date) queryParams.set("start_date", start_date)
  if (end_date) queryParams.set("end_date", end_date)
  queryParams.set("page", String(page))
  queryParams.set("per_page", String(per_page))
  if (salon_id) queryParams.set("salon_id", String(salon_id))
  return `/master/get-finances?${queryParams.toString()}`
},
    }),
   
  }),
})

export const { useGetFinancesQuery } = financeApi
